import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useEmailAttachmentTable } from "hooks/useEmailAttachmentTable";
import EmailAttachmentsService from "services/EmailAttachments";
import { Button } from "@/components/ui/button";
import Authorized from "components/Authorized";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import ACL_RELATIONSHIPS from "acl-relationships";

export const EMAIL_ATTACHMENT_TABLE_CONSTANTS = {
  tableName: "email_attachments",
  queryKey: "email_attachment",
  className: "EmailAttachment",
  exportTableName: "EmailAttachmentsTable",
  header: "Email Attachments",
  headerIcon: "mail outline",
};

const EmailAttachmentTableV3 = () => {
  const navigate = useNavigate();
  const { filters, columns } = useEmailAttachmentTable({
    className: EMAIL_ATTACHMENT_TABLE_CONSTANTS.className,
    tableName: EMAIL_ATTACHMENT_TABLE_CONSTANTS.tableName,
  });

  const fetchData = useCallback(async queryParams => {
    try {
      const response =
        await EmailAttachmentsService.getEmailAttachments(queryParams);
      return response;
    } catch (error) {
      console.error("Error fetching email attachments:", error);
      throw error;
    }
  }, []);

  const createButton = (
    <Authorized permissions={[ACL_RELATIONSHIPS.emailAttachments.create]}>
      <Button
        size="sm"
        className="item-adder"
        onClick={() => navigate("/settings/email_attachments/new")}
      >
        New Email Attachment
      </Button>
    </Authorized>
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={EMAIL_ATTACHMENT_TABLE_CONSTANTS.headerIcon}
      header={EMAIL_ATTACHMENT_TABLE_CONSTANTS.header}
      tableName={EMAIL_ATTACHMENT_TABLE_CONSTANTS.tableName}
      queryKey={EMAIL_ATTACHMENT_TABLE_CONSTANTS.queryKey}
      className={EMAIL_ATTACHMENT_TABLE_CONSTANTS.className}
      createButton={createButton}
      fetchData={fetchData}
      enableSearch
      enableSettings
    />
  );
};

export default EmailAttachmentTableV3;
